export enum AnalyticsExportPeriodicity {
  Week = 0,
  Month = 1,
}
